module.exports = __webpack_public_path__ + "static/media/custom-services-img.04378503.svg";